import { createSelector } from 'reselect';
import { Flags } from 'enums';
import routingSelector from './routingSelector';
import whitelistSelector from './whitelistSelector';

const appSelector = ({ app = {} }) => app;

export default createSelector(appSelector, (app) => app);

export const countrySelector = createSelector(appSelector, ({ country = 'us' }) => country);

export const roadblockSelector = createSelector(
    appSelector,
    whitelistSelector,
    ({ isMobile = false, options, location: { query = {} } = {} }, inWhitelist) => {
        // don't roadblock some lucky people
        if (inWhitelist) {
            return false;
        }

        if (query && query[Flags.ROADBLOCK] !== undefined) {
            return query[Flags.ROADBLOCK];
        }

        if (options && options[Flags.ROADBLOCK] !== undefined) {
            return options[Flags.ROADBLOCK];
        }

        return isMobile;
    }
);

export const playerTechSelector = createSelector(
    appSelector,
    routingSelector,
    whitelistSelector,
    ({ isMobile = false, options, location: { query = {} } = {} }, routing, inWhitelist) => {
        // always let some lucky people get brightcove player
        if (inWhitelist) {
            return 'brightcove';
        }

        if (query && query[Flags.PLAYER_TECH] !== undefined) {
            return query[Flags.PLAYER_TECH];
        }

        if (options && options[Flags.PLAYER_TECH] !== undefined) {
            return options[Flags.PLAYER_TECH];
        }

        const pathname = (routing && routing.locationBeforeTransitions && routing.locationBeforeTransitions.pathname) || '';

        if (isMobile && pathname.indexOf('shortstoplive') === -1) {
            return 'native';
        }

        return 'brightcove';
    });

export const autoPlaySelector = createSelector(appSelector, ({ location }) => {
    if (!location || !location.query) {
        return false;
    }
    return location.query.autoplay || false;
});

export const intlSelector = createSelector(
    appSelector,
    ({ locale, messages }) => ({ locale, messages })
);

export const contentIdInPlayerUrl = createSelector(routingSelector, ({ locationBeforeTransitions }) => {
    let id = null;
    if (locationBeforeTransitions && locationBeforeTransitions.pathname === '/player') {
        id = locationBeforeTransitions.query && locationBeforeTransitions.query.id;
        if (!id) {
            return true; // Return true to indicate on player page w/o ID
        }
        id = parseInt(id, 10);
    }
    return id;
});



// WEBPACK FOOTER //
// ./app/selectors/appSelector.js